import { InjectionToken } from '@angular/core';
import * as angular from 'angular';

/**
 * $timeout
 */
export let $timeout = new InjectionToken('$timeout');

export function $timeoutFactory(i: angular.auto.IInjectorService) {
    return i.get('$timeout');
}

export const $timeoutProvider = {
    deps: ['$injector'],
    provide: $timeout,
    useFactory: $timeoutFactory,
};

/**
 * $log
 */
export let $log = new InjectionToken('$log');

export function $logFactory(i: angular.auto.IInjectorService) {
    return i.get('$log');
}

export const $logProvider = {
    deps: ['$injector'],
    provide: $log,
    useFactory: $logFactory,
};

/**
 * $q
 */
export let $q = new InjectionToken('$q');

export function $qFactory(i: angular.auto.IInjectorService) {
    return i.get('$q');
}

export const $qProvider = {
    deps: ['$injector'],
    provide: $q,
    useFactory: $qFactory,
};

/**
 * $http
 */
export let $http = new InjectionToken('$http');

export function $httpFactory(i: angular.auto.IInjectorService) {
    return i.get('$http');
}

export const $httpProvider = {
    deps: ['$injector'],
    provide: $http,
    useFactory: $httpFactory,
};

/**
 * lodash
 */
export let lodash = new InjectionToken('lodash');

export function lodashFactory(i: angular.auto.IInjectorService) {
    return i.get('lodash');
}

export const lodashProvider = {
    deps: ['$injector'],
    provide: lodash,
    useFactory: lodashFactory
};